module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer_box row"
  }, _vm._l((_vm.footer), function(item, itemIndex) {
    return _c('router-link', {
      key: itemIndex,
      staticClass: "col",
      class: {
        'active': itemIndex == _vm.index
      },
      attrs: {
        "to": item.url
      }
    }, [_c('em', [_c('i', {
      staticClass: "iconfont",
      class: item.icon
    })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.title))])])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8052db20"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/footerNav/footerNav.vue
// module id = 241
// module chunks = 28